var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transparent-field transparent-multi-select-field"},[_c('common-filter',{attrs:{"showLabelFirst":true,"label":'referrals',"confirmButtonLabel":'change',"options":_vm.preparedOptions},on:{"filter-changed":_vm.filterChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }